import * as React from 'react';
import { SVGProps } from 'react';

export function InformationIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg
      style={{ width: 'inherit', height: 'inherit' }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666C11.6818 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 4.31802 11.6818 1.33325 7.99998 1.33325Z" fill="white" />
      <path d="M7.99998 6.6665C8.36818 6.6665 8.66665 6.96497 8.66665 7.33317V11.3332C8.66665 11.7014 8.36818 11.9998 7.99998 11.9998C7.63178 11.9998 7.33331 11.7014 7.33331 11.3332V7.33317C7.33331 6.96497 7.63178 6.6665 7.99998 6.6665Z" fill={fill} />
      <path d="M9 5C9 5.55229 8.55227 6 8 6C7.44773 6 7 5.55229 7 5C7 4.44771 7.44773 4 8 4C8.55227 4 9 4.44771 9 5Z" fill={fill} />
    </svg>
  );
}
